import axios from "axios";
import jwtDecode from "jwt-decode";
axios.defaults.baseURL = "https://chat-dev-node.herokuapp.com/api";
axios.defaults.headers.post["x-auth-token"] = localStorage.getItem("token");
axios.defaults.headers.get["x-auth-token"] = localStorage.getItem("token");

class backendService {
  constructor() {}
  isLoggedIn = () => {
    return localStorage.getItem("token") ? true : false;
  };
  getLoggedInUser = () => {
    try {
      const jwt = localStorage.getItem("token");
      return jwtDecode(jwt);
    } catch (ex) {
      return null;
    }
  };
  logout = () => {
    localStorage.removeItem("token");
    
    return true;
  };
  getProfilePicture = async () => {
    try {
      const response = await axios.get("/getProfilePicture");
      return response.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  };
  getToken = () => {
    return localStorage.getItem("token");
  };
}
let bS = new backendService();
export default bS;
